module.exports = "b84f20a6d8caacac7a13180654f19e17.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/sound_unmute.png
// module id = 104
// module chunks = 0